import React from "react";
import { Lock } from "lucide-react";

// Selo do card em oferta. "Sua oferta" com a porcentagem grande pra quem
// participa; "Oferta exclusiva" sem valor pra quem ainda não entrou.
export default function SeloOferta({ oferta }) {
  if (!oferta) return null;
  if (oferta.tipo === "marcado") {
    return (
      <span
        className="inline-flex items-center gap-1 text-[10px] font-black uppercase tracking-wide px-2 py-0.5 rounded-full border border-dashed border-primary text-primary"
        data-e2e="selo-oferta-marcado"
      >
        <Lock className="w-3 h-3" />
        Oferta exclusiva · entre pra ver
      </span>
    );
  }
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full bg-primary text-primary-foreground pl-2 pr-2.5 py-0.5 shadow-sm"
      data-e2e="selo-oferta"
    >
      <span className="text-[10px] font-black uppercase tracking-wide">Sua oferta</span>
      <span className="text-sm font-black leading-none">{oferta.varios ? "até " : ""}−{oferta.pct}%</span>
    </span>
  );
}

// Classes e atributos do card inteiro: fundo tingido e borda na cor da loja.
export function propsCardOferta(oferta) {
  if (!oferta) return { className: "", style: undefined, atributos: {} };
  if (oferta.tipo === "marcado") {
    return { className: "ring-1 ring-primary/60", style: undefined, atributos: { "data-oferta-marcado": "1" } };
  }
  return {
    className: "ring-2 ring-primary shadow-lg",
    style: { backgroundImage: "linear-gradient(135deg, hsl(var(--primary) / 0.16), hsl(var(--primary) / 0.04))" },
    atributos: { "data-oferta-chave": oferta.chave },
  };
}
